import React, { useMemo, useCallback } from 'react';
import { Button, Card } from 'react-bootstrap';
import Accordion from 'components/Accordion';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import useAnalysisType from 'hooks/Meteorology/Fields/ModelPerformance/useAnalysisType';
import usePeriodType from 'hooks/Meteorology/Fields/ModelPerformance/usePeriodType';
import useOptions from 'hooks/Meteorology/Fields/ModelPerformance/useOptions';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function AnalysisType() {
  const { analysisType, setAnalysisType } = useAnalysisType();
  const { periodType } = usePeriodType();
  const { analysisTypes } = useOptions();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('analysis-type-accordion'), []);

  const isDisabled = !periodType;

  const setAnalysisTypeAndClose = useCallback((value: string) => {
    setAnalysisType(value);
    closeAccordion();
  }, [setAnalysisType, closeAccordion]);

  return (
    <Accordion.Item eventKey="analysis-type" id="analysis-type-accordion">
      <Accordion.Header>
        <TitleSemiBold>Tipo de análise</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        {analysisTypes.map((type) => (
          <Card.Body key={type.id}>
            <Button
              variant="link"
              onClick={() => setAnalysisTypeAndClose(type.id)}
              disabled={isDisabled}
              className={`w-100 btn-control-panel ${analysisType === type.id ? 'btn-control-panel-active' : ''} ${isDisabled ? 'disabled' : ''}`}
            >
              {type.label}
            </Button>
          </Card.Body>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
